<template>
    <a-layout class="individual-layout">
      <IndividualInfoHeader/>
      <IndividualInfoTitle/>
      <DrivingReport @responseStatus="getResponseMsg"/>
      <ModalApiResultMsg :visible="responseMsgObj.visible" :title="responseMsgObj.title"
      :okText="responseMsgObj.okText" :cancelText="responseMsgObj.cancelText" :msgClass="responseMsgObj.msgClass"
      :okCallback="responseMsgObj.msgClass === 'msg_error_modal' ? callPhoneNumber : hideModal"
      :cancelCallback="hideModal">
      <p>{{ responseMsgObj.detailText }}</p>
    </ModalApiResultMsg>
    </a-layout>
  </template>
  
  <script>
  import IndividualInfoHeader from "../../components/individualInfo/IndividualInfoHeader.vue";
  import IndividualInfoTitle from "../../components/individualInfo/IndividualInfoTitle.vue";
  import DrivingReport from "../../components/individualInfo/IndividualDrivingReport.vue";
  // import { mapActions } from 'vuex';
  import ModalApiResultMsg from "../../components/modal/ModalApiResultMsg.vue";
  import { mixinModalMethods } from "../../utils/mixins";

  export default {
    name: 'individualDrivingReport',
    mixins: [mixinModalMethods],

    components: {
      IndividualInfoHeader,
      IndividualInfoTitle,
      DrivingReport,
      ModalApiResultMsg
    },
   
  
  }
  </script>
  